import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const OrderConfirmation = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <div className="container mx-auto max-w-md px-4 py-12">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <CheckCircle className="w-16 h-16 text-green-600" />
          </div>

          <h1 className="text-3xl font-bold mb-2">Order Confirmed!</h1>
          <p className="text-muted-foreground mb-8">
            Thank you for your purchase. Your order has been successfully placed.
          </p>

          <div className="bg-muted rounded-lg p-6 mb-8 border border-border text-left">
            <div className="space-y-4">
              <div>
                <p className="text-sm text-muted-foreground">Order Number</p>
                <p className="font-bold text-lg">#ORD-{Date.now().toString().slice(-8)}</p>
              </div>
              <div className="border-t border-border pt-4">
                <p className="text-sm text-muted-foreground mb-2">What's next?</p>
                <ul className="space-y-2 text-sm">
                  <li>✓ Order confirmation sent to your email</li>
                  <li>✓ Prepare your items for shipping</li>
                  <li>✓ Track your order in the next 24 hours</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <Button size="lg" className="w-full" onClick={() => navigate("/")}>
              Continue Shopping
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="w-full"
              onClick={() => navigate("/orders")}
            >
              View Orders
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
